<p>edit-society-cof works!</p>
